<template>
  <div class="topbar d-flex text-white justify-center line-liff-header-font">
    <div class="display-size px-4 py-2 base-brown d-flex align-center">
      <v-col cols="8" class="py-0">
        <div class="text-ellipsis">
          <span v-html="title" class="tracking-wide custom-fontsize"></span>
        </div>
      </v-col>
      <v-col cols="4" class="d-flex justify-end tracking-wide py-0">
        <div @click="changeLang('th')" :class="{ active: lang == 'th' }" class="liff-line-font-lexendDeca">
          TH
        </div>
        <div class="mx-1"> | </div>
        <div @click="changeLang('en')" :class="{ active: lang == 'en' }" class="liff-line-font-lexendDeca">
          EN
        </div>
      </v-col>
    </div>
  </div>
</template>
<script>
export default {
    name: 'TopBar',
    props: {
        title: String
    },
    data: function () {
        return {
            lang: 'en'
        }
    },
    created: function () {
        const current = localStorage.getItem('lang')
        this.lang = current
        this.$vuetify.lang.current = current
    },
    methods: {
        changeLang: function (lang) {
            this.lang = lang
            this.$vuetify.lang.current = lang
            localStorage.setItem('lang', lang)
            this.$emit('changeLange', lang)
            window.location.reload()
        }
    }
}
</script>
<style lang="scss" scoped>
@import "@/styles/color.scss";
.custom-fontsize {
  font-size: 20px;
}
.topbar {
  z-index: 100;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;

  .active {
    color: $base-orange;
    border-bottom: 1px solid $base-orange;
  }
  .display-size {
    width: 100%;
    max-width: 500px;
  }
}
::v-deep .topbar__content{
    display: inline-block !important;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.text-ellipsis {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>
